;$(function() {

	var page = {};
	page.product = $('.product-share');
	page.share 	 = $('.product-share .ya-share2');

	var action = {};
	action.show = () => {
		if (page.share.css('display') == 'none')
			page.share.slideDown();
	}
	action.hide = () => {
		if (page.share.css('display') != 'none')
			page.share.slideUp();
	}

	action.hide();

	page.product
		.mouseenter(action.show)
		.mouseleave(action.hide);

});